import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/audioGuide/ticket.png';
import _imports_1 from '@/assets/audioGuide/r_ticket.png';
import _imports_2 from '@/assets/audioGuide/picture.png';
import _imports_3 from '@/assets/audioGuide/r_picture.png';
import _imports_4 from '../assets/audioGuide/location.png';
import _imports_5 from '@/assets/audioGuide/r_location.png';
const _withScopeId = n => (_pushScopeId("data-v-3b7ae5a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "exhibitionItem"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "exhibition-name"
};
const _hoisted_5 = {
  class: "typeWarp"
};
const _hoisted_6 = {
  key: 0,
  class: "type"
};
const _hoisted_7 = {
  key: 0,
  class: "eye",
  src: _imports_0
};
const _hoisted_8 = {
  key: 1,
  class: "eye",
  src: _imports_1
};
const _hoisted_9 = {
  class: "number"
};
const _hoisted_10 = {
  class: "type"
};
const _hoisted_11 = {
  key: 0,
  class: "eye",
  src: _imports_2
};
const _hoisted_12 = {
  key: 1,
  class: "eye",
  src: _imports_3
};
const _hoisted_13 = {
  class: "number"
};
const _hoisted_14 = {
  key: 1,
  class: "type"
};
const _hoisted_15 = {
  key: 0,
  class: "eye",
  src: _imports_4
};
const _hoisted_16 = {
  key: 1,
  class: "eye",
  src: _imports_5
};
const _hoisted_17 = {
  class: "number"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.exhibitions, item => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.showExhitonList(item),
      class: "exhibition"
    }, [_createElementVNode("img", {
      class: "exhibition-img",
      src: item.images
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString($props.language ? item.exhibName : item.en_name), 1), _createElementVNode("div", _hoisted_5, [item.price ? (_openBlock(), _createElementBlock("div", _hoisted_6, [!$props.special ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8)), _createElementVNode("span", _hoisted_9, _toDisplayString(item.price), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [!$props.special ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : (_openBlock(), _createElementBlock("img", _hoisted_12)), _createElementVNode("span", _hoisted_13, _toDisplayString($props.language ? item.exhibType : $options.getType(item.exhibType)), 1)]), item.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!$props.special ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : (_openBlock(), _createElementBlock("img", _hoisted_16)), _createElementVNode("span", _hoisted_17, _toDisplayString($props.language ? item.exhibitionLocation : item.en_location), 1)])) : _createCommentVNode("", true)]), _hoisted_18], 8, _hoisted_2);
  }), 256))]);
}